import { render, staticRenderFns } from "./vehicleList.vue?vue&type=template&id=2da937a4&scoped=true&"
import script from "./vehicleList.vue?vue&type=script&lang=js&"
export * from "./vehicleList.vue?vue&type=script&lang=js&"
import style0 from "./vehicleList.vue?vue&type=style&index=0&id=2da937a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da937a4",
  null
  
)

export default component.exports